module.exports = __webpack_public_path__ + "img/FRK.b8b1c195.svg";